import React, { useState } from 'react';
import { LayoutChangeEvent, StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

export interface GasOfferCardProps {
  priceTitle: string;
  currentPrice: string;
  actualPrice: string;
  pricePerUnit: string;
}

export const containerPadding = theme.spacing.m;

const GasOfferCard = ({
  priceTitle,
  currentPrice,
  actualPrice,
  pricePerUnit,
}: GasOfferCardProps) => {
  const [priceRowWidth, setPriceRowWidth] = useState<number | null>(null);

  const onLayoutChange = (event: LayoutChangeEvent) => {
    const width = event.nativeEvent.layout.width;
    setPriceRowWidth(width + containerPadding * 2);
  };

  return (
    <View
      style={[
        styles.container,
        priceRowWidth ? { width: priceRowWidth } : null,
      ]}
      testID="gas-offer-card-container"
    >
      <BodyBaseText numberOfLines={1}>{priceTitle}</BodyBaseText>
      <View
        style={styles.currentPriceWrap}
        testID="current-price-wrapper"
        onLayout={onLayoutChange}
      >
        {currentPrice || actualPrice ? (
          <>
            <TitleMdText>{currentPrice}</TitleMdText>
            <BodySmText style={styles.actualPrice}>{actualPrice}</BodySmText>
          </>
        ) : (
          <TitleMdText>-</TitleMdText>
        )}
      </View>
      <BodyBaseText numberOfLines={1} style={styles.pricePerUnit}>
        {pricePerUnit ?? '-'}
      </BodyBaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  actualPrice: {
    color: theme.color.text.secondary,
    textDecorationLine: 'line-through',
  },
  container: {
    alignSelf: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: theme.color.background.primary,
    borderColor: theme.color.border.primarySolid,
    borderRadius: 4,
    borderWidth: 1,
    flexDirection: 'column',
    minWidth: 135,
    padding: containerPadding,
  },
  currentPriceWrap: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.xs,
    marginTop: theme.spacing.s,
  },
  pricePerUnit: {
    color: theme.color.interactive.primary,
    marginTop: theme.spacing.xs,
  },
});

export default GasOfferCard;
